import {
    Box, Button, FormControl, FormControlLabel, MenuItem,
    Modal, Radio, RadioGroup, Select, TextField
} from '@mui/material';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { getBusinessTypeFn, getMainHeaderFn, getSellerListFn, postHeaderFn, updateHeaderFn } from 'Services/Header';

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    rounded: 2,
};

const AddCustomiseHeaderForm = ({ open, handleClose, header, refetchHeader }) => {
    const { data: getSellerListResponse } = useQuery({
        queryKey: ["get-seller-list"],
        queryFn: getSellerListFn
    });
    const getSellerList = getSellerListResponse?.data?.data;

    const { data: getBusinessTypeResponse } = useQuery({
        queryKey: ["get-business-type-list"],
        queryFn: getBusinessTypeFn
    });
    const getBusinessType = getBusinessTypeResponse?.data?.data;

    const { data: getMainHeaderResponse } = useQuery({
        queryKey: ['get-main-header'],
        queryFn: getMainHeaderFn
    })

    const { mutate: postHeader } = useMutation(postHeaderFn, {
        onSuccess: (response) => {
            if (response?.status === 200) {
                toast.success(response.data?.message);
                handleClose();
                refetchHeader();
            }
        }
    });

    const { mutate: updateHeader } = useMutation(updateHeaderFn, {
        onSuccess: (response) => {
            if (response?.status === 200) {
                toast.success(response.data?.message);
                handleClose();
                refetchHeader();
            }
        }
    });

    const formik = useFormik({
        initialValues: {
            title: header?.title || "",
            image: null,
            url: header?.url || "",
            business_type: header?.business_type || "",
            seller: header?.seller || "",
            mainheader: header?.mainheader || "",
            subheader: header?.subheader || "",
            options: header?.business_type ? "business_type" : header?.seller ? "seller" : "business_type"
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append('title', values.title);
            formData.append('url', values.url);
            formData.append('mainheader', values.mainheader);
            if (values.options === "seller" && values.seller) {
                formData.append('seller', values.seller);
                formData.append('business_type', "");
            } else if (values.options === "business_type" && values.business_type) {
                formData.append('business_type', values.business_type);
                formData.append('seller', "");
            }
            if (header) formData.append('header_id', header.id);

            if (header) {
                if (header && values.image) formData.append('image', values.image);
                updateHeader(formData);
            } else {

                if (!values.image) {
                    return toast.error("Image is required.")
                }
                formData.append('image', values.image);
                postHeader(formData);
            }
        }
    });

    const closeHandle = () => {
        handleClose();
        formik.handleReset();
    }

    return (
        <Modal
            open={open}
            onClose={closeHandle}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
        >
            <Box
                sx={{ ...style, width: 930 }}
                className="rounded-2xl !border-0"
            >
                <form onSubmit={formik.handleSubmit}>
                    <div id="child-modal-title" className="!text-black !underline !font-bold !py-3 !text-center !text-xl">
                        {header == null ? "Add Customization Header" : "Update Customization Header"}
                    </div>
                    <div className="flex justify-between w-full">
                        <div className="w-[48%]">
                            <div>Title :</div>
                            <TextField
                                size="small"
                                name="title"
                                value={formik.values.title}
                                onChange={formik.handleChange}
                                id="outlined-basic"
                                className="!w-[100%] !mt-1"
                            />
                            <div className="mt-2">Image :</div>
                            <TextField
                                name="image"
                                onChange={(event) => formik.setFieldValue("image", event.currentTarget.files[0])}
                                id="outlined-basic"
                                type="file"
                                size="small"
                                className="!w-[100%] !mt-1"
                            />
                        </div>
                        <div className="w-[48%]">
                            <div>URL :</div>
                            <TextField
                                name="url"
                                value={formik.values.url}
                                onChange={formik.handleChange}
                                id="outlined-basic"
                                size="small"
                                className="!w-[100%] !mt-1"
                            />
                            <div>Main Header :</div>
                            <FormControl fullWidth>
                                <Select
                                    name="mainheader"
                                    size="small"
                                    className="mt-2"
                                    value={formik.values.mainheader}
                                    onChange={formik.handleChange}
                                >
                                    {getMainHeaderResponse?.data?.data?.data?.map((elem) => (
                                        <MenuItem value={elem?.id} key={elem?.id}>
                                            {elem?.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="mt-2">
                        <div>Select Header :</div>
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="options"
                                value={formik.values.options}
                                onChange={formik.handleChange}
                            >
                                <FormControlLabel
                                    value="business_type"
                                    control={<Radio />}
                                    label="Business Type"
                                />
                                <FormControlLabel
                                    value="seller"
                                    control={<Radio />}
                                    label="Seller"
                                />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    {formik.values.options === "business_type" && (
                        <div className="mt-2">
                            <div>Select Business Type :</div>
                            <FormControl fullWidth>
                                <Select
                                    name="business_type"
                                    size="small"
                                    className="mt-2"
                                    value={formik.values.business_type}
                                    onChange={formik.handleChange}
                                >
                                    {getBusinessType?.map((elem) => (
                                        <MenuItem value={elem?.id} key={elem?.id}>
                                            {elem?.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    )}
                    {formik.values.options === "seller" && (
                        <div className="mt-2">
                            <div>Select Seller :</div>
                            <FormControl fullWidth>
                                <Select
                                    name="seller"
                                    size="small"
                                    className="mt-2"
                                    value={formik.values.seller}
                                    onChange={formik.handleChange}
                                >
                                    {getSellerList?.map((elem) => (
                                        <MenuItem value={elem?.id} key={elem?.id}>
                                            {elem?.company}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    )}
                    <Button
                        onClick={closeHandle}
                        variant="contained"
                        color="warning"
                        className="!py-2 !mt-3"
                    >
                        CANCEL
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="success"
                        className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    >
                        {header === null ? "ADD" : "UPDATE"}
                    </Button>
                </form>
            </Box>
        </Modal>
    );
}

export default AddCustomiseHeaderForm;
